import React from "react";
import { CURRENCY_RATES } from "../../data/currencyRates";

const LORA = { fontFamily: "'Lora', Georgia, serif" };
const SERIF = { fontFamily: "'Cormorant Garamond', Georgia, serif" };

export function BudgetSetupModal({ show, total, setupVal, currency, onSetupValChange, onCurrencyChange, onConfirm, onClose }) {
  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center px-4"
      style={{ background: "rgba(43,38,35,0.65)" }}
    >
      <div
        className="w-full max-w-sm bg-[#F9F6F0] p-6"
        style={{ borderRadius: "3px", border: "1px solid #DCD4C6" }}
      >
        <h2 className="text-3xl mb-1" style={{ ...SERIF, fontWeight: 600, color: "#2B2623" }}>
          {total ? "Modifier le budget" : "Définir le budget"}
        </h2>
        <p className="text-sm text-[#9A8F86] italic mb-4" style={LORA}>
          Sauvegardé localement sur cet appareil — fonctionne hors-ligne.
        </p>

        {/* Budget amount */}
        <div className="relative mb-3">
          <input
            type="number"
            min="1"
            step="50"
            autoFocus
            className="w-full border border-[#DCD4C6] bg-white px-4 py-3 text-2xl pr-12 focus:outline-none focus:border-[#C17F59] transition-colors"
            style={{ ...SERIF, fontWeight: 600, borderRadius: "2px" }}
            placeholder="Ex: 1 500"
            value={setupVal}
            onChange={(e) => onSetupValChange(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && onConfirm()}
            data-testid="input-budget-setup"
          />
          <span className="absolute right-4 top-1/2 -translate-y-1/2 text-xl text-[#9A8F86]" style={SERIF}>€</span>
        </div>

        {/* Currency selector */}
        <div className="mb-4">
          <p className="text-xs uppercase tracking-widest text-[#8B5E34] mb-1.5" style={LORA}>
            Devise locale du voyage
          </p>
          <select
            className="w-full border border-[#DCD4C6] bg-white px-3 py-2 text-sm focus:outline-none focus:border-[#C17F59] transition-colors"
            style={{ ...LORA, borderRadius: "2px" }}
            value={currency}
            onChange={(e) => onCurrencyChange(e.target.value)}
            data-testid="select-currency"
          >
            {Object.entries(CURRENCY_RATES).map(([code, info]) => (
              <option key={code} value={code}>
                {`${info.flag} ${code} — ${info.name} (${info.symbol})`}
              </option>
            ))}
          </select>
        </div>

        <div className="flex gap-3">
          {total && (
            <button
              onClick={onClose}
              className="flex-1 py-2.5 border border-[#DCD4C6] text-sm text-[#5C554E] hover:border-[#8B5E34] transition-colors"
              style={{ ...LORA, borderRadius: "2px" }}
            >
              Annuler
            </button>
          )}
          <button
            onClick={onConfirm}
            disabled={!setupVal || parseFloat(setupVal) <= 0}
            className="flex-1 py-2.5 bg-[#C17F59] text-[#F9F6F0] text-sm hover:bg-[#A86A46] disabled:opacity-40 transition-colors font-medium"
            style={{ ...LORA, borderRadius: "2px" }}
            data-testid="btn-confirm-budget"
          >
            Confirmer
          </button>
        </div>
      </div>
    </div>
  );
}
